module.exports = __webpack_public_path__ + "media/images/photo/top/img_photo-ab6cbad494ef929570570153300e147b.jpg";